import { Component, Input } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'uw-action-item',
    templateUrl: './action-item.component.html',
    styleUrls: ['./action-item.component.scss'],
    imports: [ReactiveFormsModule, TranslateModule]
})
export class ActionItemComponent {
  @Input() index: number = 0;
  @Input() actionsForm!: UntypedFormGroup;
}
